import React, { useEffect } from "react";

import { X } from "lucide-react";

import {
  RelationshipRingsGraph,
  RelationshipRingsLegend,
} from "./RelationshipRingsGraph";

function RelationshipRingsFullModal({
  open,
  account,
  contacts,
  considerMeddpiccRole = false,
  onClose,
  onMappedContactClick,
  userName,
  centerUserStakeholder,
}) {
  useEffect(() => {
    if (!open) return undefined;
    const handleKeyDown = event => {
      if (event.key === "Escape") {
        event.stopPropagation();
        onClose?.();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [open, onClose]);

  if (!open || !account) return null;

  return (
    <div
      className="modal-bg open rl-prototype-skin"
      role="presentation"
      onClick={event => {
        if (event.target === event.currentTarget) onClose?.();
      }}
    >
      <div
        className="modal rings-full-modal"
        role="dialog"
        aria-labelledby="rings-full-modal-title"
        onClick={event => event.stopPropagation()}
      >
        <header className="rings-full-modal-hdr">
          <div className="rings-full-modal-hdr-text">
            <h2 id="rings-full-modal-title" className="rings-full-modal-title">
              {account.name}
              {" — Relationship Rings"}
            </h2>
            <p className="rings-full-modal-sub">
              Closer to center = stronger relationship · Click a mapped contact
              to assess · Dashed = not yet mapped
            </p>
          </div>
          <button
            type="button"
            className="rings-full-modal-close"
            onClick={onClose}
            aria-label="Close full view"
          >
            <X style={{ width: 20, height: 20 }} aria-hidden />
          </button>
        </header>

        <div className="rings-full-modal-body">
          {contacts.length === 0 ? (
            <div className="t3-l2-empty">
              <b>You are not mapped to anyone here yet</b>
              <span>
                Add a mapping in the Coverage Matrix, then come back to assess.
              </span>
            </div>
          ) : (
            <>
              <div className="rings-full-modal-canvas">
                <RelationshipRingsGraph
                  contacts={contacts}
                  mode="modal"
                  considerMeddpiccRole={considerMeddpiccRole}
                  onMappedContactClick={onMappedContactClick}
                  userName={userName}
                  centerUserStakeholder={centerUserStakeholder}
                />
              </div>
              <RelationshipRingsLegend
                variant="modal"
                considerMeddpiccRole={considerMeddpiccRole}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default RelationshipRingsFullModal;
